// @flow
import api, { sleep } from '../../configs/api-generators.js';
import { setProgress, setMessages, setModal } from '../ui/ui.actions.js';
import { extractMessages } from '../ui/ui.helpers.js';

import { ADD_CARD, DELETE_CARD } from './card.const.js';
import type { Strype } from './card.types.js';

export function* addCard(stripe: ?Strype, cardElement: ?HTMLElement): Yield<*> {
  try {
    if (!stripe || !cardElement) throw new Error('Problems with payment service, please try again later');

    yield setProgress(true, ADD_CARD);

    const payResponse = yield stripe.createSource(cardElement, {
      type: 'card',
    });

    if (payResponse.error) {
      throw new Error(payResponse.error.message);
    }

    const response = yield* api('/cards/add/', {
      stripeToken: payResponse.source.id
    });

    if (response.ok) {
      yield {
        type: ADD_CARD,
        payload: { card: response.data.card }
      };

      yield setProgress(false, ADD_CARD);

      yield setMessages(extractMessages(response));
      yield sleep(1000);
      return setModal(false, ADD_CARD);
    }

    throw new Error(
      response && response.error && response.error.length
        ? response.error.join('\n')
        : 'Internal Server Error'
    );
  } catch (e) {
    yield setMessages({
      type: 'error',
      text: e.message
    });
    return setProgress(false, ADD_CARD);
  }
}

export function* deleteCard(cardId: string): Yield<*> {
  try {
    yield setProgress(true, DELETE_CARD);

    const response = yield* api(`/cards/delete/${cardId}/`, {});

    if (response.ok) {
      yield {
        type: DELETE_CARD,
        payload: { card: { id: cardId } }
      };

      yield setMessages(extractMessages(response));
      return setProgress(false, DELETE_CARD);
    }

    throw new Error(
      response && response.error && response.error.length
        ? response.error.join('\n')
        : 'Internal Server Error'
    );
  } catch (e) {
    yield setMessages({
      type: 'error',
      text: e.message
    });
    return setProgress(false, DELETE_CARD);
  }
}
